import { useQuery } from "@tanstack/react-query";
import { trpc, useTRPC } from "../../../shared/api/trpc";

export type WorkspaceMember = Awaited<ReturnType<typeof trpc.access.members.query>>[number];

export function useWorkspaceMembers(enabled = true) {
  const trpc = useTRPC();
  const membersQuery = useQuery({ ...trpc.access.members.queryOptions(), enabled, staleTime: 60_000 });

  return {
    // People only. Service accounts are members for access purposes, but
    // nobody assigns work to one or mentions it in a comment.
    data: (membersQuery.data ?? []).filter((member) => !member.isServiceAccount),
    isLoading: membersQuery.isPending,
  };
}
